// components/Dialog/icons.ts — Icon rendering per type
import React from 'react';
import type { Dialog } from '../../contexts/DialogContext';
import CheckCircleFilledIcon from '../icons/CheckCircleFilledIcon';
import XCircleIcon from '../icons/XCircleIcon';
import TrashIcon from '../icons/TrashIcon';

export const getDialogIcon = (icon?: string) => {
    switch (icon) {
        case 'check':
            return (
                <div className="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-emerald-100 dark:bg-emerald-900/30">
                    <CheckCircleFilledIcon className="h-6 w-6 text-emerald-600 dark:text-emerald-400" />
                </div>
            );
        case 'warning':
            return (
                <div className="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-amber-100 dark:bg-amber-900/30">
                    <svg className="h-6 w-6 text-amber-600 dark:text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                </div>
            );
        case 'trash':
            return (
                <div className="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 dark:bg-red-900/30">
                    <TrashIcon className="h-6 w-6 text-red-600 dark:text-red-400" />
                </div>
            );
        case 'info':
            return (
                <div className="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 dark:bg-blue-900/30">
                    <svg className="h-6 w-6 text-blue-600 dark:text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                </div>
            );
        case 'question':
            return (
                <div className="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-indigo-100 dark:bg-indigo-900/30">
                    <svg
                        className="h-6 w-6 text-indigo-600 dark:text-indigo-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
            );
        default:
            return null;
    }
};

export const getDialogTypeStyles = (type?: string) => {
    switch (type) {
        case 'danger':
            return {
                confirmBtn: 'bg-destructive hover:bg-destructive/90 text-destructive-foreground',
            };
        case 'warning':
            return {
                confirmBtn: 'bg-warning hover:bg-warning/90 text-warning-foreground',
            };
        case 'success':
            return {
                confirmBtn: 'bg-success hover:bg-success/90 text-success-foreground',
            };
        case 'info':
            return {
                confirmBtn: 'bg-primary hover:bg-primary/90 text-primary-foreground',
            };
        default:
            return {
                confirmBtn: 'bg-primary hover:bg-primary/90 text-primary-foreground',
            };
    }
};
